// Main layout components
export { default as AdminLayout } from './layouts/AdminLayout.vue';

// Core components
export { default as Header } from './components/Header.vue';
export { default as Sidebar } from './components/Sidebar.vue';

// UI components
export { default as Card } from './components/ui/Card.vue';
export { default as StatsCard } from './components/ui/StatsCard.vue';

// Dashboard components
export { default as DashboardPage } from './components/dashboard/DashboardPage.vue';
export { default as RecentFeedbacks } from './components/dashboard/RecentFeedbacks.vue';
export { default as NpsChart } from './components/dashboard/NpsChart.vue';
export { default as ScoreDistribution } from './components/dashboard/ScoreDistribution.vue';

// Composables
export { default as useDarkMode } from './composables/useDarkMode';
export { default as useNotifications } from './composables/useNotifications';